import { useEffect, useState } from "react";

export function useTranscriptState(storageKey: string = "liveAgentTranscriptOpen") {
  const [open, setOpen] = useState<boolean>(false);
  const [userScrolledUp, setUserScrolledUp] = useState<boolean>(false);

  useEffect(() => {
    const persisted = localStorage.getItem(storageKey);
    if (persisted === "1") setOpen(true);
  }, [storageKey]);

  useEffect(() => {
    localStorage.setItem(storageKey, open ? "1" : "0");
  }, [open, storageKey]);

  return { open, setOpen, userScrolledUp, setUserScrolledUp } as const;
}


